import { Folder } from '@dc-shared-web/hooks'
import { AxiosInstance } from 'axios'
export interface RenameFolderParams {
  folderId: string
  newFolderName: string
  oldFolderName: string
}

export interface RenameFolderParamsNew {
  folderUuid: string
  newFolderName: string
  oldFolderName: string
  office_uuid?: string
  parent_type?: string | null
  parent_uuid?: string | null
}

export const renameFolder = async (
  apiClient: AxiosInstance,
  params: RenameFolderParams
) => {
  const { data: axiosData } = await apiClient.postForm(
    `/ajax/folders/${params.folderId}/rename`,
    {
      id: params.folderId,
      name: params.newFolderName,
    }
  )
  return axiosData.data
}

export const renameFolderNew = async (
  apiClient: AxiosInstance,
  params: RenameFolderParamsNew
): Promise<Folder> => {
  const { data } = await apiClient.patch(`/api/folders/${params.folderUuid}`, {
    name: params.newFolderName,
    office_uuid: params.office_uuid,
    parent_type: params.parent_type,
    parent_uuid: params.parent_uuid,
  })

  return data
}
